import React from "react";

const FileDownloadRow = ({
  fileIcon,
  fileName,
  downloadIcon,
  onDownload,
  fileSize,
}) => (
  <div className="flex justify-between items-center">
    <div className="flex items-center gap-4">
      <img src={fileIcon} alt="File Type Icon" />
      <div>
        <p className="body text-black">{fileName}</p>
       {fileSize && (
        <p className="small">{fileSize}</p>
       )} 
      </div>
    </div>
    <img
      src={downloadIcon}
      alt="Download Icon"
      className="cursor-pointer"
      onClick={onDownload}
    />
  </div>
);

export default FileDownloadRow;
